import requestCountry from 'js/lib/requestCountry';
import { isAuthenticatedUser } from 'js/lib/user';

export const shouldShowToUBanner = () => {
  return isAuthenticatedUser() && requestCountry.get() !== 'US';
};
